import { Switch as SwitchPrimitive } from "@base-ui/react/switch";
import { cn } from "../lib/utils";

/**
 * On or off, such as "in stock". The track is 44 × 24 px; an invisible margin
 * makes the touch target 48 px or more. Give it an accessible name with
 * `aria-label` or an enclosing label.
 */
function Switch({
	className,
	...props
}: Omit<SwitchPrimitive.Root.Props, "className"> & { className?: string }) {
	return (
		<SwitchPrimitive.Root
			data-slot="switch"
			className={cn(
				"relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-transparent bg-input p-0.5 transition-colors outline-none after:absolute after:-inset-3 after:content-[''] focus-visible:ring-3 focus-visible:ring-ring/50 data-checked:bg-primary data-disabled:cursor-not-allowed data-disabled:opacity-50 dark:bg-input/80",
				className,
			)}
			{...props}
		>
			<SwitchPrimitive.Thumb
				data-slot="switch-thumb"
				className="pointer-events-none block size-5 rounded-full bg-background shadow-sm transition-transform duration-150 ease-out data-checked:translate-x-5"
			/>
		</SwitchPrimitive.Root>
	);
}

export { Switch };
